import { useField } from "formik";
import Select from "components/form/Select";

import task_status_data from "libs/task_status_data.json";

const Status = ({ name, optionsDisabled, ...rest }) => {
  const [field, , helpers] = useField(name);

  const selected = task_status_data.find((item) => item.value === field.value);

  return (
    <Select.Status
      {...rest}
      selected={selected}
      optionsDisabled={optionsDisabled}
      onChange={(option) => helpers.setValue(option.value)}
    />
  );
};

export default Status;
